module.exports = __webpack_public_path__ + "static/img/checked.374bf853.svg";